const PagesTypes = {
  ARTICLE: 'Article',
  STATIC: 'Static',
  VIDEO: 'Video',
  GAMES: 'Game',
};

export default PagesTypes;

